<template>
  <div>
    <!-- 버튼 리스트 -->
    <vs-row v-if="isSuperUser" >
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <div class="mb-4 ml-auto">
          <vs-button class="ml-4" color="secondary" type="border" @click="onClickMoveList">목록</vs-button>
          <vs-button class="ml-4" color="secondary" type="border" @click="onClickReturn">기본값으로</vs-button>
          <vs-button class="ml-4" color="secondary" @click="onClickSave">저장</vs-button>
        </div>
      </vs-col>
    </vs-row>

    <!-- 첫번째 색션 -->
    <vs-row>
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot"></i> 징후감지(초기대응) + 비상대응 및 수습복구
        </h5>
        <div v-if="isSuperUser" class="ml-auto">
          <vs-button color="secondary" @click="addRow('징후감지_비상대응및수습복구')"> 항목추가 </vs-button>
          <vs-button color="secondary" type="border" class="ml-2" @click="deleteRow('징후감지_비상대응및수습복구')"> 마지막 항목삭제 </vs-button>
        </div>
      </vs-col>
    </vs-row>
    <vs-row class="my-4">
      <table class="mb-4 table-wrap">
        <tr>
          <th class="p-4 th-cell">번호</th>
          <th class="p-4 th-cell">비상조치 절차도 (예시)</th>
          <th class="p-4 th-cell">내용</th>
        </tr>
        <tr v-for="(data, i) in form.징후감지_비상대응및수습복구">
          <td class="p-4 td-cell" >
            <ml-input v-if="isSuperUser" class="w-full" v-model="data.no"/>
            <span v-else>{{ data.no }}</span>
          </td>
          <td class="p-4 td-cell" >
            <ml-input v-if="isSuperUser" class="w-full" v-model="data.input1"/>
            <span v-else>{{ data.input1 }}</span>
          </td>
          <td class="p-4 td-cell" >
            <ml-input v-if="isSuperUser" class="w-full" v-model="data.input2"/>
            <span v-else>{{ data.input2 }}</span>
          </td>
        </tr>
      </table>
    </vs-row>
  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'

export default {
  components: {
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  computed: {
    isSuperUser() {
      return !!this.myInfo.is_superuser
    },
    myInfo () {
      return this.$store.state.auth.userInfo
    },
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
    list () {
      return this.$store.state.board.postListInfo.data
    },
    default_징후감지_비상대응및수습복구() {
      return [
        { no: '1', input1: '징후 접수', input2: '' },
        { no: '2', input1: '징후전파 및 보고', input2: '' },
        { no: '3', input1: '징후 대응 조치', input2: '' },
        { no: '4.1', input1: '상황판단', input2: '▶ 5. 상황 관리 or 6.1 통지본 운영 or 6.2 수습·복구 활동 or (확대·확산시) 6.3 지대본 운영으로 전개' },
        { no: '4.2', input1: '사고발생', input2: '상황접수 > 상황전파 및 보고 > 재난상황실 운영 > 현장 출동 및 대응 ▶ 4.1 상황판단' },
        { no: '5', input1: '상황 관리', input2: '▶ 10. 상황 종료' },
        { no: '6.1', input1: '통지본 운영', input2: '> 6.2 수습·복구 활동 or (보고/지원요청시) 6.3 지대본 운영' },
        { no: '6.2', input1: '수습·복구 활동', input2: '▶ 7. 수습·복구 완료' },
        { no: '7', input1: '수습·복구 완료', input2: '' },
        { no: '8', input1: '비상기구 해체', input2: '' },
        { no: '9', input1: '상황 모니터링', input2: '' },
        { no: '10', input1: '', input2: '상황종료' },
      ]
    },
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler (/*value*/) {
      }
    },
    value: {
      important: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    },
    list(list) {
      if (list.length > 0) {
        const data = JSON.parse(list[0].post_content)
        this.form = data.body
      }
    }
  },
  async mounted () {
    this.initForm()
    await this.loadListBoard()
  },
  data () {
    return {
      form: {
        징후감지_비상대응및수습복구: [],
      },
    }
  },
  methods: {
    initForm () {
      this.form.징후감지_비상대응및수습복구 = JSON.parse(JSON.stringify(this.default_징후감지_비상대응및수습복구))
    },
    onClickReturn () {
      this.initForm();
    },
    onClickMoveList () {
      this.$router.back()
    },
    onClickSave () {
      if (this.list && this.list.length > 0) {
        this.saveBoardPost("update");
      } else {
        this.saveBoardPost("create");
      }
    },
    addRow (form_key) {
      this.form[form_key].push({ no: '', input1: '', input2: '' })
    },
    deleteRow (form_key) {
      this.form[form_key].pop()
    },
    async loadListBoard () {
      const boardId = this.boardId
      const page = 1
      const perPage = 5
      await this.$store.dispatch('board/LOAD_POST_LIST', {
        projectId: this.projectId,
        boardId,
        page,
        perPage,
      })
    },
    async saveBoardPost(type) {
      const form = {
        header: {
          full: new Date().format('yyyy-MM-dd'),
          month: new Date().getMonth()+1,
          year: new Date().getFullYear(),
        },
        body: this.form,
        summary: {}
      };

      const projectId = this.projectId;
      const boardId = this.boardId;
      const title = '비상조치 및 처리 절차 안내';
      const content = JSON.stringify(form);

      if (type === "create") {
        await this.$store.dispatch("board/CREATE_POST", {
          projectId,
          boardId,
          title,
          content,
        });
      } else if (type === "update") {
        const postId = this.list[0].id;
        await this.$store.dispatch("board/UPDATE_POST", {
          projectId,
          boardId,
          postId,
          title,
          content,
        });
      }
      this.oldForm = JSON.parse(JSON.stringify(this.form));
    },
  }
}
</script>

<style scoped>
.table-wrap {
  width: 100%;
  border-spacing: 0;
  border-top: 1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;
}

.th-cell {
  white-space: nowrap;
  border-right: 1px solid #cdcdcd;
  border-bottom: 1px solid #cdcdcd;
  background-color: #f9f9f9;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
}

.th-cell:nth-child(1) {
  max-width: 130px;
  width: 130px;
}

.th-cell:nth-child(2) {
  max-width: 390px;
  width: 390px;
}

.td-cell {
  font-weight: 500;
  white-space: nowrap;
  border-right: 1px solid #cdcdcd;
  border-bottom: 1px solid #cdcdcd
}
.td-cell:nth-child(1) {
  text-align: center;
}
</style>

